<template>
  <section class="notice-container clearfix" v-if="firstPartNotice.length || secondsPartNotice.length">
    <div class="notice-title"></div>
    <div class="notice-content">
      <t-loading :loading="loading" show-overlay>
        <t-swiper
          class="tdesign-demo-block--swiper"
          direction="vertical"
          :navigation="{ showSlideBtn: 'never' }"
          :height="46"
          :autoplay="true"
          :interval="3000"
          v-if="firstPartNotice.length"
        >
          <t-swiper-item v-for="item in firstPartNotice" :key="item">
            <ul>
              <li v-for="(item2, index2) in item" :key="index2">
                <span class="circle"><i></i></span>
                <router-link :to="{ name: 'NoticeInfo', params: {target: sessionTarget, id: item2.noticeId }}" @click="$send('vschool_shouyepeizhi_notice_link', {'sessionTarget': sessionTarget})">
                  {{item2.title}}
                </router-link>
              </li>
            </ul>
          </t-swiper-item>
        </t-swiper>
      </t-loading>
    </div>
    <div class="notice-line"></div>
    <div class="notice-content">
      <t-loading :loading="loading" show-overlay>
        <t-swiper
          class="tdesign-demo-block--swiper"
          direction="vertical"
          :navigation="{ showSlideBtn: 'never' }"
          :height="46"
          :autoplay="true"
          :interval="3000"
          v-if="secondsPartNotice.length"
        >
          <t-swiper-item v-for="item in secondsPartNotice" :key="item">
            <ul>
              <li v-for="(item2, index2) in item" :key="index2">
                <span class="circle"><i></i></span>
                <router-link :to="{ name: 'NoticeInfo', params: {target: sessionTarget, id: item2.noticeId }}">
                  {{item2.title}}
                </router-link>
              </li>
            </ul>
          </t-swiper-item>
        </t-swiper>
      </t-loading>
    </div>
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(['noticeList', 'sessionTarget', 'queryUserPromise']),
    firstPartNotice () {
      return this.noticeList.filter((item, index) => {
        if (index % 2 === 0) {
          return true
        }
      })
    },
    secondsPartNotice () {
      return this.noticeList.filter((item, index) => {
        if (index % 2 === 1) {
          return true
        }
      })
    }
  },
  mounted () {
    this.queryUserPromise.then(() => {
      this.loadData()
    })
  },
  methods: {
    loadData () {
      this.loading = true
      this.queryNoticeOverviews({
        pageNo: 1,
        pageSize: 18
      }).then(() => {
        this.loading = false
      })
    },
    ...mapActions(['queryNoticeOverviews'])
  }
}
</script>

<style lang="scss" scoped>
.notice-container {
  background: url(../../assets/img/notice-bg.png) no-repeat;
  background-size: 100% 98px;
  height: 99px;
  margin-top: 25px;
  .notice-title {
    float: left;
    background: url(../../assets/img/notice-title.png) no-repeat;
    width: 48px;
    height: 58px;
    margin-left: 50px;
    margin-top: 20px;
  }
  .notice-content {
    float: left;
    margin-left: 50px;
    margin-top: 28px;
    display: inline-block;
    width: 545px;
    ul {
      height: 46px;
      li {
        line-height: 20px;
        height: 23px;
        .circle {
          display: inline-block;
          margin-right: 8px;
          line-height: 12px;
          font-size: 0;
          overflow: hidden;
          i {
            display: inline-block;
            width: 2px;
            height: 2px;
            background: #333;
            font-size: 0;
            overflow: hidden;
            position: relative;
            top:2px;
          }
        }
      }
    }
  }
  .notice-line {
    float: left;
    margin-top: 25px;
    width: 1px;
    height: 51px;
    background: url(../../assets/img/notice-gap.png) no-repeat;
  }
  /deep/ .t-swiper__navigation {
    display: none;
  }
}
</style>
